// A module to start and monitor the progress of long running server tasks.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    startRequest: function() {
        return startRequest;
    },
    messagesToErrorString: function() {
        return messagesToErrorString;
    },
    messagesToPreString: function() {
        return messagesToPreString;
    },
    messageByName: function() {
        return messageByName;
    }
});
const startRequest = (startingURL, // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
body, options = {})=>new Promise((resolve, reject)=>{
        if (options.onStart) {
            options.onStart();
        }
        const pollingInterval = options.pollingIntervalMs || 200;
        // Regardless if this is the first fetch, or any of the subsequent polling
        // fetches, we do the same exact processing on the Promise, so consolidate all
        // the functionality into a single function.
        const processFetch = (fetchPromise)=>{
            fetchPromise.then(async (resp)=>{
                if (!resp.ok) {
                    const errText = await resp.text();
                    throw new Error(errText || `Bad network response: ${resp.statusText}`);
                }
                return resp.json();
            }).then((json)=>{
                if (options.onProgressUpdate) {
                    options.onProgressUpdate(json);
                }
                if (json.status === 'Running') {
                    window.setTimeout(()=>{
                        processFetch(fetch(json.url, {
                            method: 'GET'
                        }));
                    }, pollingInterval);
                } else {
                    if (options.onSuccess) {
                        options.onSuccess(json);
                    }
                    if (options.onSettled) {
                        options.onSettled();
                    }
                    resolve(json);
                }
            }).catch((msg)=>{
                if (options.onSettled) {
                    options.onSettled();
                }
                reject(msg);
            });
        };
        // Make the initial request that starts the polling process.
        processFetch(fetch(startingURL, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json'
            }
        }));
    });
const messagesToErrorString = (messages)=>{
    if (!messages || messages.length === 0) {
        return '(no error message available)';
    }
    const errorMessages = messages.filter((msg)=>{
        var _msg;
        return ((_msg = msg) === null || _msg === void 0 ? void 0 : _msg.key) === 'Error';
    });
    if (errorMessages.length === 1) {
        return errorMessages.map((msg)=>{
            var _msg, _msg1;
            return `${(_msg = msg) === null || _msg === void 0 ? void 0 : _msg.key}: ${(_msg1 = msg) === null || _msg1 === void 0 ? void 0 : _msg1.value}`;
        }).join('');
    }
    return messages.map((msg)=>{
        var _msg, _msg1;
        return `${(_msg = msg) === null || _msg === void 0 ? void 0 : _msg.key}: ${(_msg1 = msg) === null || _msg1 === void 0 ? void 0 : _msg1.value}`;
    }).join(' ');
};
const messagesToPreString = (messages)=>messages.map((msg)=>`${msg.key}: ${msg.value}`).join('\n');
const messageByName = (messages, key, fallback = '')=>{
    if (!messages || messages.length === 0) {
        return fallback;
    }
    const matching = messages.filter((msg)=>{
        var _msg;
        return ((_msg = msg) === null || _msg === void 0 ? void 0 : _msg.key) === key;
    });
    if (matching.length === 1) {
        return matching[0].value;
    }
    return fallback;
};
